import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CardTool, CardToolsGroup } from '../../schema/card-tools-group';

@Component({
  selector: 'app-callcard-tools-modal',
  templateUrl: './callcard-tools-modal.component.html',
  styleUrls: ['./callcard-tools-modal.component.scss']
})
export class CallcardToolsModalComponent implements OnInit {
  @Input()
  cardToolGroups: CardToolsGroup[] = [];

  openedAccordions: string[];
  selectedTool: CardTool = null;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.openedAccordions = this.cardToolGroups.map(group => group.name);
  }

  onToolSelected(tool: CardTool) {
    if (this.selectedTool == tool) {
      this.selectedTool = null;
    } else {
      this.selectedTool = tool;
    }
  }

  onDismiss() {
    this.modalController.dismiss();
  }

  onSubmit() {
    this.modalController.dismiss(this.selectedTool);
  }
}
